var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7872 2.90324L14.2431 8.49994H20.757L20.2128 2.90324C20.163 2.39085 19.7323 2 19.2175 2H15.7825C15.2677 2 14.837 2.39085 14.7872 2.90324Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.762C7 5.82671 5.83054 5.4033 5.23178 6.12182L2.46357 9.44367C2.16404 9.8031 2.00001 10.2562 2.00001 10.724L2 20.9999C2 21.5522 2.44772 21.9999 3 21.9999H21C21.5523 21.9999 22 21.5522 22 20.9999V10.9999C22 10.4477 21.5523 9.99994 21 9.99994H12V6.762C12 5.82671 10.8305 5.4033 10.2318 6.12182L7.00001 9.99994L7 6.762ZM8.75 15V18C8.75 18.4142 8.41421 18.75 8 18.75C7.58579 18.75 7.25 18.4142 7.25 18V15C7.25 14.5858 7.58579 14.25 8 14.25C8.41421 14.25 8.75 14.5858 8.75 15ZM12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V15C11.25 14.5858 11.5858 14.25 12 14.25ZM16.75 15V18C16.75 18.4142 16.4142 18.75 16 18.75C15.5858 18.75 15.25 18.4142 15.25 18V15C15.25 14.5858 15.5858 14.25 16 14.25C16.4142 14.25 16.75 14.5858 16.75 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.2e3ce17a0b89108d1f27cccd04101106.svg";
export { ForwardRef as ReactComponent };